import { ComponentSize, COMPONENT_SIZE_LARGE, COMPONENT_SIZE_RESPONSIVE } from '../typings/design-tokens';

export const isLargeOrResponsive = (size: ComponentSize) =>
  size === COMPONENT_SIZE_LARGE || size === COMPONENT_SIZE_RESPONSIVE;
